import * as AccommodationService from '~/services/AccommodationService';

import { CatalogItemAssociationConfig } from '../types/catalogItem';

export const propertyFacilityAssociationConfig: CatalogItemAssociationConfig<
  AccommodationService.AdminFacility,
  AccommodationService.AdminPropertyFacility,
  AccommodationService.PropertyFacilityAddPayload,
  AccommodationService.PropertyFacilityUpdatePayload
> = {
  // Service methods
  listAllItems: async (params) => {
    const response = await AccommodationService.listFacilities(params);
    return {
      ...response,
      result: {
        items: response.result.facilities,
      },
    };
  },
  listAssociatedItems: async (pathParams, queryParams) => {
    const response = await AccommodationService.listPropertyFacilities(
      { propertyId: pathParams.propertyId },
      {
        ...queryParams,
        status: queryParams.status as 'approved' | 'draft',
      },
    );
    return {
      ...response,
      result: {
        items: response.result.facilities,
        total: response.result.total,
      },
    };
  },
  getAllAssociatedItemCodes: async (pathParams, queryParams) => {
    const response = await AccommodationService.listPropertyFacilities(
      { propertyId: pathParams.propertyId },
      {
        ...queryParams,
        status: queryParams.status as 'approved' | 'draft',
      },
    );
    return {
      ...response,
      result: {
        items: response.result.facilities,
      },
    };
  },
  addItem: async (pathParams, data) => {
    return await AccommodationService.addPropertyFacility({ propertyId: pathParams.propertyId }, data);
  },
  updateItem: async (pathParams, data) => {
    return await AccommodationService.updatePropertyFacility(
      { propertyId: pathParams.propertyId, facilityCode: pathParams.facilityCode },
      data,
    );
  },
  removeItem: async (pathParams) => {
    return await AccommodationService.removePropertyFacility({
      propertyId: pathParams.propertyId,
      facilityCode: pathParams.facilityCode,
    });
  },

  // Query keys
  allItemsQueryKey: ['accommodation', 'facilities', 'all'],
  associatedItemsQueryKey: (propertyId) => ['accommodation', 'property-facilities', propertyId],
  allAssociatedCodesQueryKey: (propertyId) => ['accommodation', 'property-facilities', propertyId, 'all-codes'],

  // Labels
  itemName: 'Facility',
  itemNamePlural: 'Facilities',
  associationContext: 'property',
  hasAssociationValue: true,
};
